import { Calendar, Hash, List, Tag, ToggleLeft, Type } from "lucide-react";
import type { SVGProps } from "react";

import type { FilterDefinition } from "./FilterDefinition";

/**
 * Single icon per `FilterDataType`. Reused by the field picker rows and the
 * right-pane field header so the type cue is consistent.
 *
 * Per-definition overrides (e.g. fingerprint for resource-id flavored
 * string fields) are supplied via `FilterDefinition.icon` at the picker
 * and form-header callsites — this helper is the type-default fallback.
 */
export function FieldTypeIcon({
  type,
  className,
}: {
  type: FilterDefinition["type"];
  className?: SVGProps<SVGSVGElement>["className"];
}) {
  switch (type) {
    case "string":
      return <Type className={className} />;
    case "numeric":
      return <Hash className={className} />;
    case "date":
      return <Calendar className={className} />;
    case "boolean":
      return <ToggleLeft className={className} />;
    case "set":
      return <Tag className={className} />;
    case "enum":
      return <List className={className} />;
  }
}
